import React from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';

class StarRack extends React.Component {
  static propTypes = {
    maxStars: PropTypes.number,
    showUnfilled: PropTypes.bool,
    rating: PropTypes.number.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    maxStars: 5,
    showUnfilled: true,
    className: undefined,
  };

  renderStar = (number) => {
    const { rating } = this.props;

    return (
      <i
        key={number}
        className={[
          'icon',
          'icon-review-star',
          number <= rating ? 'active' : '',
        ].join(' ')}
      />
    );
  };

  render() {
    const {
      maxStars,
      showUnfilled,
      rating,
      className,
    } = this.props;

    const displayRange = (showUnfilled ? maxStars : rating) + 1;

    return (
      <div className={className}>
        {range(1, displayRange).map(this.renderStar)}
      </div>
    );
  }
}

export default StarRack;
